import { render, staticRenderFns } from "./jinkou.vue?vue&type=template&id=2476fc3c&scoped=true&"
import script from "./jinkou.vue?vue&type=script&lang=js&"
export * from "./jinkou.vue?vue&type=script&lang=js&"
import style0 from "./jinkou.vue?vue&type=style&index=0&id=2476fc3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476fc3c",
  null
  
)

export default component.exports